/**
 * Функция фиксации хедера
 */
$.fn.slidingTabs = function() {
    const $self = $(this);
    const $teamNames = $self.find('.js-team-name');
    const $playersFilter = $self.find('.js-filter-players');
    const $playersListsWrapper = $self.find('.js-players-lists-wrapper');
    const $arena = $self.find('.js-arena');

    $teamNames.on('click', function () {
        if (window.innerWidth < SVK.breakpoint["tablet-min"])
        $teamNames.removeClass('active');
        $(this).addClass('active');

        $playersFilter.toggleClass('transform');
        $playersListsWrapper.toggleClass('transform');
        $arena.toggleClass('transform');
    });
};
